<template>
  <main-layout>
    <template v-if="currentView == 'catalog'">
      <v-container>
        <v-layout>
          <v-flex>
            <div class="headline">Intervention Catalog</div>
          </v-flex>
          <v-flex shrink>
            <v-btn
              color="primary"
              depressed
              :outline="showSearch"
              @click="showSearch = !showSearch"
            >
              Search
            </v-btn>
            <v-btn
              :disabled="!selected || selected.length == 0"
              color="primary"
              @click="onImportSelected"
              :loading="loading"
            >
              Import
            </v-btn>
          </v-flex>
        </v-layout>

        <v-card v-if="showSearch">
          <v-card-text>
            <div class="headline primary--text">Search</div>
            <v-layout>
              <v-flex class="pa-1">
                <div class="caption">Bot Name</div>
                <v-text-field
                  name="botname"
                  single-line
                  id="botname"
                  v-model="advanceSearch.botname"
                  color="primary"
                  outline
                  hide-details
                ></v-text-field
              ></v-flex>
              <v-flex class="pa-1">
                <div class="caption">Template</div>
                <v-text-field
                  name="template"
                  single-line
                  id="template"
                  v-model="advanceSearch.template"
                  color="primary"
                  outline
                  hide-details
                ></v-text-field
              ></v-flex>
              <v-flex class="pa-1">
                <div class="caption">Flow Name</div>
                <v-text-field
                  name="flowname"
                  single-line
                  id="flowname"
                  v-model="advanceSearch.flowname"
                  color="primary"
                  outline
                  hide-details
                ></v-text-field
              ></v-flex>
            </v-layout>
            <div class="text-xs-right">
              <v-btn color="primary" @click="onSearch">Search</v-btn>
            </div>
          </v-card-text>
        </v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="flows"
          :pagination.sync="pagination"
          :total-items="total"
          :loading="loading"
          class="elevation-1 mt-3"
          select-all
          item-key="id"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.flowname }}</td>
            <td class="text-xs-left">{{ props.item.description || '-' }}</td>
            <td>{{ props.item.botname || '-' }}</td>
            <td>{{ props.item.template || '-' }}</td>
            <td class="text-xs-left">{{ props.item.owneradminid || '-' }}</td>
            <td class="text-xs-right">
              <v-btn outline small @click="onImport(props.item)" :loading="loading">
                import
              </v-btn>
              <!-- <v-btn outline small @click=";(selectedFlow = props.item), (currentView = 'flow')">
                view flow
              </v-btn> -->
            </td>
          </template>
        </v-data-table>
      </v-container>
    </template>
    <template v-if="selectedFlow && currentView == 'flow'">
      <div
        class="text-xs-right"
        style="overflow-x: auto;white-space: nowrap;position: absolute;border-bottom: 1px solid #F5F4F4; background: #F5F4F499; top: 0;left: 0;right: 0; z-index: 2"
      >
        <v-layout>
          <v-flex shrink>
            <v-btn
              small
              fab
              outline
              class="mt-3"
              v-if="selectedFlow"
              @click="
                currentView = 'catalog'
                intents = null
              "
              ><v-icon>arrow_back</v-icon></v-btn
            >
          </v-flex>
          <template v-if="selectedFlow">
            <v-flex shrink>
              <v-chip color="warning" class="mt-3 white--text" disabled
                >{{ selectedFlow.flowname }}
                <v-icon small class="ml-2">lock</v-icon>
              </v-chip>
            </v-flex>
            <v-flex style="max-width: 400px">
              <v-text-field
                dense
                label="Search Node"
                id="searchNode"
                v-model="search"
                single-line
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex>
          </template>
          <template v-else>
            <!-- <v-flex style="max-width: 400px" class="pl-2">
              <v-text-field
                dense
                label="Search Flow"
                id="searchFlow"
                single-line
                v-model="searchFlow"
                hide-details
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex> -->
          </template>

          <v-flex>
            <v-dialog v-model="showVariable" width="1000">
              <template v-slot:activator="{ on }">
                <v-btn
                  outline
                  color="primary"
                  v-on="on"
                  class="hidden-xs-only mt-3"
                  :loading="loadingVariableList"
                  :disabled="!selectedFlow"
                >
                  <v-icon class="mr-2">edit</v-icon>
                  <span>Local Variable</span>
                </v-btn>
                <v-btn
                  outline
                  color="primary"
                  v-on="on"
                  small
                  fab
                  class="hidden-sm-and-up mt-3"
                  :loading="loadingVariableList"
                  :disabled="!selectedFlow"
                  ><v-icon small>edit</v-icon></v-btn
                >
              </template>
              <v-card>
                <div class="text-xs-right">
                  <v-btn flat fab small @click="showVariable = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <local-variable-setting
                  v-if="!loadingVariableList && selectedFlow"
                ></local-variable-setting>
              </v-card>
            </v-dialog>
            <!-- <v-dialog v-model="showSetting" width="1000">
              <template v-slot:activator="{ on }">
                <v-btn outline color="primary" v-on="on" class="hidden-xs-only mt-3">
                  <v-icon class="mr-2">settings_applications</v-icon>
                  <span>setting</span>
                </v-btn>

                <v-btn outline color="primary" v-on="on" small fab class="hidden-sm-and-up mt-3"
                  ><v-icon small>settings_applications</v-icon></v-btn
                >
              </template>
              <v-card>
                <div class="text-xs-right">
                  <v-btn fab flat small @click="showSetting = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
                <v-tabs fixed-tabs v-model="settingTab">
                  <v-tab :key="'globalvariable'" :href="'#globalvariable'">Global Variable</v-tab>
                  <v-tab :key="'api'" :href="'#api'">API</v-tab>
                  <v-tab :key="'flow'" :href="'#flow'">Flow</v-tab>
                  <v-tab :key="'export'" :href="'#export'">Export</v-tab>
                </v-tabs>

                <div v-if="settingTab == 'globalvariable'">
                  <global-variable-setting v-if="!loadingFlowList"></global-variable-setting>
                </div>
                <div v-if="settingTab == 'localvariable'"></div>
                <div v-if="settingTab == 'api'">
                  <api-setting></api-setting>
                </div>
                <div v-if="settingTab == 'flow'">
                  <flow-setting></flow-setting>
                </div>
                <div v-if="settingTab == 'export'">
                  <v-container>
                    <div class="text-xs-center">
                      Import flow
                    </div>
                    <v-layout>
                      <v-flex class="pa-1">
                        <v-btn
                          block
                          color="primary"
                          depressed
                          @click="onClickUploadButton"
                          :disabled="!intents"
                          :loading="loadingExport"
                        >
                          Import
                        </v-btn>
                      </v-flex>
                      <v-flex class="pa-1">
                        <v-btn
                          block
                          color="primary"
                          depressed
                          @click="exportFlow"
                          :disabled="!intents"
                          :loading="loadingExport"
                        >
                          Export
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </div>
              </v-card>
            </v-dialog> -->
          </v-flex>
        </v-layout>
      </div>
      <flow
        v-model="selectedFlow"
        :key="selectedFlow.id"
        @loadIntent="loadIntent"
        :search="search"
        :isEdit="false"
      ></flow>
    </template>
  </main-layout>
</template>

<script>
import copyNodeMixin from '@/mixins/copyNodeMixin.js'
import { mapGetters } from 'vuex'
import Flow from '@/components/view/flow/Flow.vue'
import api from '@/api'
import { cloneDeep } from 'lodash'
export default {
  mixins: [copyNodeMixin],
  components: {
    Flow
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      loadingFlowList: 'getLoadingFlowList',
      loadingVariableList: 'getLoadingVariableList',
      variableList: 'getVariableList'
    })
  },
  data() {
    return {
      advanceSearch: {
        botname: '',
        template: '',
        flowname: ''
      },
      showSearch: false,
      showVariable: false,
      currentView: 'catalog',
      flows: [],
      total: 0,
      rowsPerPageItems: [2, 10, 20, 30, 50, 100],
      pagination: {
        rowsPerPage: 50
      },
      loading: false,
      selected: [],
      search: '',
      headers: [
        {
          text: 'Flowname',
          value: 'flowname',
          sortable: false
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false
        },
        { text: 'Bot Origin', value: 'botname', sortable: false },
        { text: 'Template', value: 'template', sortable: false },
        {
          text: 'Owner',
          value: 'owneradminid',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ],
      selectedFlow: null
    }
  },
  watch: {
    pagination: {
      async handler() {
        await this.loadFlow()
        // this.getDataFromApi().then(data => {
        //   this.desserts = data.items
        //   this.totalDesserts = data.total
        // })
      },
      deep: true
    }
  },
  async mounted() {
    await this.$store.dispatch('loadAllVariable')
    // await this.loadFlow()
  },
  methods: {
    async onSearch() {
      this.$set(this.pagination, 'page', 1)
      await this.loadFlow()
    },
    onImport(flow) {
      let selected = [flow]
      this.importFlows(selected)
    },
    onImportSelected() {
      if (this.selected) {
        this.importFlows(this.selected)
      }
    },
    async cloneIntents(intents, flowid, oldflowid, flows) {
      if (intents.length > 0) {
        intents = JSON.parse(JSON.stringify(intents))
        var newNodes = await this.getCopyNode(intents, flowid)
        var updateNodePromise = []
        if (newNodes) {
          newNodes.forEach(el => {
            let replace_flow = null

            if (
              ['node', 'start_node', 'api', 'condition', 'savevariables', 'flow'].includes(el.type)
            ) {
              el.answer[0].forEach((answer, aindex) => {
                if (['text', 'button'].includes(answer.type))
                  el.answer[0][aindex].text = el.answer[0][aindex].text.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                else if (answer.type == 'api') {
                  el.answer[0][aindex].req = el.answer[0][aindex].req.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                  el.answer[0][aindex].update = el.answer[0][aindex].update.replaceAll(
                    `flow${oldflowid}.`,
                    `flow${flowid}.`
                  )
                } else if (answer.type == 'condition') {
                  el.answer[0][aindex].condition.forEach((condition, cindex) => {
                    if (el.answer[0][aindex].condition[cindex].case)
                      el.answer[0][aindex].condition[cindex].case = el.answer[0][aindex].condition[
                        cindex
                      ].case.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                    if (el.answer[0][aindex].condition[cindex].caseText)
                      el.answer[0][aindex].condition[cindex].caseText = el.answer[0][
                        aindex
                      ].condition[cindex].caseText.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                  })
                } else if (el.type == 'savevariables') {
                  el.answer[0][aindex].variables.forEach((variable, vindex) => {
                    el.answer[0][aindex].variables[vindex].text = el.answer[0][aindex].variables[
                      vindex
                    ].text.replaceAll(`flow${oldflowid}.`, `flow${flowid}.`)
                  })
                } else if (el.type == 'flow') {
                  replace_flow = flows.find(flow => {
                    return flow.oldname == el.answer[0][aindex].flowname
                  })

                  if (replace_flow) {
                    el.answer[0][aindex].flowname = replace_flow.flowname
                    // ผิด ต้อง replace ด้วย node id
                    // el.connected_intents[0].to = replace_flow.id
                  }
                }
              })
            }
          })
          if (this.variableList) {
            let variables =
              this.variableList && this.variableList.length > 0
                ? this.variableList.filter(el => {
                    return el.flowid == oldflowid
                  })
                : []

            if (variables && variables.length > 0) {
              let variablePromises = variables.map(variable => {
                return this.cloneVariable(variable, flowid, oldflowid)
              })

              await Promise.all(variablePromises)
            }
          }

          updateNodePromise = newNodes.map(node => {
            return this.updateNode(newNodes, node)
          })
          await Promise.all(updateNodePromise)
        }

        return newNodes
      }
    },
    cloneVariable(payload, flowid, oldflowid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`flow${oldflowid}.`, `flow${flowid}.`)
        data.flowid = flowid

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    cloneGlobalVariable(payload, pageid, oldpageid) {
      return new Promise((resolve, reject) => {
        var data = cloneDeep(payload)
        delete data.id
        data.name = data.name.replace(`${oldpageid}.`, `${pageid}.`)

        api.addVariable(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data && response.data.length > 0) {
            resolve({ ...response.data[0], oldid: payload.id })
          } else {
            reject()
          }
        })
      })
    },
    updateNode(intents, payload) {
      return new Promise((resolve, reject) => {
        var intent = intents.find(el => {
          return el.id == payload.id
        })

        if (intent) {
          var data = cloneDeep(intent)
          data.x = parseInt(payload.x)
          data.y = parseInt(payload.y)
          data.question = data.question ? data.question : ''
          data.connected_intents = JSON.stringify(data.connected_intents)
          data.answer = JSON.stringify(data.answer)
          data.quick_reply = data.quick_reply ? data.quick_reply : ''
          api.editNode(data, function(error, response) {
            if (error) {
              reject(error)
            }
            resolve()
          })
        } else {
          reject()
        }
      })
    },
    async importFlows(select) {
      var vm = this
      var result = await vm.$swal.fire({
        title: vm.$t('Do you want to transfer this?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      this.loading = true

      if (result.value && select.length > 0) {
        var flowPromise = []

        for (let index = 0; index < select.length; index++) {
          const flow = select[index]
          flowPromise.push(this.cloneFlow(flow))
        }

        let flows = await Promise.all(flowPromise)

        let allnodes = []
        if (flows) {
          for (let index = 0; index < flows.length; index++) {
            const flow = flows[index]
            var intents = await this.getFlowAllIntents(flow.oldid)
            intents = this.convertJsonToObject(intents)

            let newNodes = await this.cloneIntents(intents, flow.id, flow.oldid, flows)
            if (newNodes) allnodes = [...allnodes, ...newNodes]
          }

          try {
            let filterLinkFlow = allnodes
              .filter(el => el.type == 'flow')
              .map(el => {
                let target_node = allnodes.find(node => node.oldid == el.connected_intents[0].to)
                if (target_node) {
                  el.connected_intents[0].to = target_node.id
                  return el
                } else {
                  return null
                }
              })
              .filter(el => el != null)

            if (filterLinkFlow.length > 0) {
              let updateNodePromise = filterLinkFlow.map(node => {
                return this.updateNode(filterLinkFlow, node)
              })
              await Promise.all(updateNodePromise)
            }
          } catch (error) {
            console.error(error)
          }
        }

        await this.$swal.fire({
          type: 'success',
          title: this.$t('Success')
        })
        this.loading = false
      }
    },
    async cloneFlow(flow) {
      if (flow) {
        // var flowname = `${flow.flowname}`
        try {
          var responsenewflow = await this.addNewFlow({
            ...flow,
            // flowname: flowname,
            // template: flow.template,
            x: 0,
            y: 0,
            zoom: 1,
            adminid: this.$store.state.userid,
            pageidlist: this.selectedBot.pageid,
            ispublic: false
          })

          if (
            responsenewflow &&
            responsenewflow.responsecode == 200 &&
            responsenewflow.data &&
            responsenewflow.data.length > 0
          ) {
            var newflow = responsenewflow.data[0]

            // if (flow.pageidlist) {
            //   let pageidlist = flow.pageidlist.split(',')
            //   if (pageidlist.length > 0) {
            //     let pageid = pageidlist[0]
            //     let variables = this.variableList.filter(variable => {
            //       return variable.name.indexOf(pageid + '.') != -1
            //     })
            //     variables.forEach(variable => {
            //       this.cloneGlobalVariable(variable, this.selectedBot.pageid, pageid)
            //     })
            //   }
            // }

            return { ...newflow, oldid: flow.id, oldname: flow.flowname }
          }
        } catch (error) {
          console.error(error)
        }
      }
      return Promise.resolve()
    },
    async addNewFlow(data) {
      this.loadingAddFlow = true
      try {
        var response = await api.addFlowDetail(data)

        // await this.$store.dispatch('loadFlowList')
        return Promise.resolve(response)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    convertJsonToObject(intents) {
      return intents.map((intent, index) => {
        var i = intent
        try {
          i.answer = JSON.parse(intent.answer)
        } catch (error) {
          i.answer = []
        }
        try {
          i.connected_intents =
            intent.connected_intents != null ? JSON.parse(intent.connected_intents) : []
        } catch (error) {
          i.connected_intents = []
        }
        i.userinput = {}
        if (i.x == null) {
          i.x = 0
        }
        if (i.y == null) {
          i.y = 0
        }
        return i
      })
    },

    getFlowAllIntents(flowid) {
      return new Promise((resolve, reject) => {
        var data = { flowid: flowid }
        api.getFlowAllIntents(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    loadIntent(intents) {
      //   this.intents = intents
    },
    async loadFlow() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination

      let response = await this.getPublicFlowList({
        limit: rowsPerPage,
        offset: (page - 1) * rowsPerPage,
        ispublic: true,
        ...this.advanceSearch
      })

      this.flows = response || []
      this.total = 0

      if (this.flows.length > 0 && this.flows[0].total) {
        this.total = parseInt(this.flows[0].total)
      }
      this.loading = false
    },
    getPublicFlowList(options) {
      return new Promise((resolve, reject) => {
        var data = {
          adminid: this.$store.state.userid,
          pageid: this.$store.state.selectedBot.pageid,
          ...options
        }
        api.getPublicFlowList(data, function(error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            resolve(response.data)
          } else {
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/InterventionCatalog/Main.vue